import React from "react";
import styles from "./Sidebar.module.css"
import logo from "../../../assets/logo.png"
import logoutPng from "../../../assets/log.png"

const Sidebar = ({ activeElement, handleClick, openModal, isMenuExpanded, menuItems }) => {
    return (
        <div className={`${styles.sidebar} ${isMenuExpanded ? styles.collapseSidebar : ""}`}>
            <div className={styles.elementWrapper}>

                <div className={styles.heading}>
                    <img src={logo} alt="Logo" className={styles.headingLogo} />
                </div>

                {menuItems.map((item) => (
                    <div
                        key={item.key}
                        className={activeElement === item.key ? styles.sidebarelementactive : styles.sidebarelement}
                        onClick={() => handleClick(item.key)}
                    >
                        <img
                            src={activeElement === item.key ? item.activeIcon : item.icon}
                            alt={item.label}
                        />
                        <p
                            className={`${styles.elementText} ${isMenuExpanded ? styles.hideElementText : ""}`}
                        >
                            {item.label}
                        </p>
                    </div>
                ))}
            </div>

            <div className={styles.logoutWrapper} onClick={openModal}>
                <img src={logoutPng} alt="Logout" className={styles.logout} />
                <p
                    className={`${styles.elementText} ${isMenuExpanded ? styles.hideElementText : ""}`}
                >
                    Logout
                </p>
            </div>
        </div>
    );
};

export default Sidebar;
